<!-- Renovação de sessão do Acesso Cidadão -->
@if (shouldWaitForAcessoCidadaoRenewal) {
    <div class="lds-dual-ring"></div>
    <div class="acesso-cidadao-renewing">
        <p><b>Aguarde enquanto sua sessão do Acesso Cidadão é renovada...</b></p>
        <span>Esta janela fechará automaticamente quando a renovação for concluída</span>
    </div>
} @else if (authService.$user() != null) {
    <div class="page-container">
        <div class="page-wrapper p-4">
            <h1 class="page-title m-0">
                <i class="fas fa-home mr-3"></i>
                <span>Olá, {{getUserName()}}</span>
            </h1>

            <p class="page-subtitle m-0 pl-3 pt-3 pr-2 pb-2">
                <i class="fas fa-level-up-alt mr-2"></i>
                Confira aqui informações sobre o E-Flow, o volume de serviços de suas principais Caixas de Fluxo e acesse funcionalidades diversas do Portal Admin
            </p>

            <hr />

            <div class="working-area styled-scrollbar">
                @if ($stats().length > 0) {
                    @for (announcement of $announcements(); track announcement) {
                        <announcer [_title]="announcement.title"
                                   [_message]="announcement.message"
                                   [_level]="announcement.level"
                        ></announcer>
                    }
                }

                <!-- Estatísticas -->
                <div class="section mt-5 p-4">
                    <h5 class="section-title mb-4">
                        <i class="fas fa-folder-open mr-2"></i>
                        <span>Meus Fluxos Ativos</span>
                    </h5>

                    <div class="cards-container">
                        @if ($stats()?.length == 0) {
                            <ngx-spinner name="counts" bdColor="rgba(0, 0, 0, 0)" size="medium" color="#64b2cd" type="line-scale-pulse-out-rapid" [fullScreen]="false"></ngx-spinner>
                        } @else {
                            <home-item _type="stat"
                                       _statLabel="TOTAL"
                                       [_statCounter]="$totalFlowDefinitions()"
                                       (_goToEvent)="goToFlowDefinitionList()"
                            ></home-item>

                            @for (stat of $stats(); track stat) {
                                <home-item _type="stat"
                                           [_statLabel]="getFlowInboxLabel(stat)"
                                           [_statCounter]="stat?.count"
                                           (_goToEvent)="goToFlowDefinitionList(stat?.unitId)"
                                ></home-item>
                            }
                        }
                    </div>
                </div>

                <!-- Ações Rápidas -->
                <div class="section mt-5 p-4">
                    <h5 class="section-title mb-4">
                        <i class="fas fa-rocket mr-2"></i>
                        <span>Ações Rápidas</span>
                    </h5>

                    <div class="actions-container">
                        <home-item _type="action"
                                   _actionTitle="Novo Fluxo"
                                   _actionDescription="Inicie a construção de um novo Fluxo"
                                   _actionIconClass="fas fa-plus-circle"
                                   [_actionRouterLink]="[Enums.PagesPaths.FlowDefinition]"
                        ></home-item>

                        <home-item _type="action"
                                   _actionTitle="Dashboard"
                                   _actionDescription="Obtenha dados e estatísticas sobre a execução de seus Fluxos no E-Flow"
                                   _actionIconClass="fas fa-chart-pie"
                                   [_actionRouterLink]="[Enums.PagesPaths.Dashboard]"
                        ></home-item>

                        <home-item _type="action"
                                   _actionTitle="Atualizações"
                                   _actionDescription="Confira as últimas atualizações da plataforma E-Flow"
                                   _actionIconClass="fas fa-timeline"
                                   [_actionRouterLink]="[Enums.PagesPaths.UpdateHistory]"
                        ></home-item>

                        <home-item _type="action"
                                   _actionTitle="Documentação"
                                   _actionDescription="Acesse a página de documentação do E-Flow com informações e vídeo-aulas"
                                   _actionIconClass="fas fa-info-circle"
                                   [_actionHref]="Enums.PagesPaths.Documentation"
                        ></home-item>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal de Atualizações -->
    <ng-container>
        @if (isLatestUpdateFound) {
            <update-history (_latestUpdateFoundEvent)="onLatestUpdateFound($event)" style="display: none;"></update-history>
        }

        <ng-template #updateHistoryModalRef let-data>
            <div cdkFocusInitial>
                <update-history [_isModal]="true"></update-history>
            </div>
            <div class="modal-footer pt-4 pr-4">
                <button type="button" class="btn btn-outline-secondary" (click)="dontShowAgain(data.latestId)">
                    Entendido, não mostrar novamente
                </button>
                <button type="button" class="btn btn-outline-primary" (click)="updateHistoryDialogRef.close()">
                    Fechar
                </button>
            </div>
        </ng-template>
    </ng-container>
}
